import { useEffect } from 'react';
import { Box, Text, VStack, Heading } from '@primerai/thread';
import { useLocation } from 'wouter';

import { STEPS } from './constants';
import { useVerificationStatus, useVerifyResetToken } from './helpers';
import { withBranding, UNAUTHENTICATED } from '~/components/branding';
import { RESET_TOKEN_PARAM } from '~/constants';
import { LOGIN } from '~/routes/paths';
import { useTokenFromHash } from '~/utils/browser';

const ConfirmEmail = () => {
  const [, navigate] = useLocation();
  const step = useVerificationStatus();
  const resetToken = useTokenFromHash(RESET_TOKEN_PARAM);
  const verifyResetToken = useVerifyResetToken();

  useEffect(() => {
    if (resetToken) {
      verifyResetToken(resetToken);
    }
  }, [resetToken]);

  switch (step) {
    case STEPS.VERIFY:
      return <div>Confirming email...</div>;
    case STEPS.REDIRECT_TO_LOGIN:
      navigate(LOGIN);
      return null;
    default:
    case STEPS.LINK_RESENT:
      return (
        <VStack>
          <Heading mb="$2">Oops, looks like your link has expired</Heading>
          <Box mb="$8">
            <Text>
              We&apos;ve emailed you a new link so that you can activate your
              account
            </Text>
          </Box>
        </VStack>
      );
  }
};
export default withBranding(UNAUTHENTICATED)(ConfirmEmail);
